import type { RestaurantListFilter } from '@/features/restaurants/api'
import { type PageSearch, parsePageSearch } from '@/lib/page-search'

export interface RestaurantListSearch extends PageSearch {
  filter?: RestaurantListFilter
}

/** `?filter=deletable` narrows the list to deletion candidates (K4); anything else is the whole list. */
export function parseRestaurantListSearch(search: Record<string, unknown>): RestaurantListSearch {
  const page = parsePageSearch(search)
  return search.filter === 'deletable' ? { ...page, filter: 'deletable' } : page
}
